import { Text } from '@modusign/design-system';

function DefaultBadge() {
  return (
    <Text
      as="p"
      backgroundColor="statusBackgroundEmphasisUltraLight"
      color="textEmphasisBase"
      display="inline-block"
      fontSize="xs"
      fontWeight="medium"
      py="2px"
      sx={{ borderRadius: '10px', height: '20px', width: '38px' }}
      textAlign="center"
    >
      기본
    </Text>
  );
}

export default DefaultBadge;
